import axios from 'axios'

export default {
    get: () => axios.get('customers'),
    store: (data) => axios.post('customers/store', data),
    update: (data) => axios.post('customers/update', data),
    delete: (id) => axios.post('customers/delete', id),
    import: (data) => axios.post('customers/import', data),
    importStatus: (importId) => axios.get('customers/import-status/' + importId),
    getBySupplier: (user_id) => axios.get('customers/'+user_id+'/by-supplier'),
}